/**
 * `data-screen-label="Agent"`, tab `test` — THE place to test this agent.
 *
 * AMENDED 2026-09-25 (customer-portal review #117, #125): testing lived in three places with three
 * different abilities and one wrong promise ("the runtime is not running"); every refusal is the API's
 * own words, read when the tab opens (review #166).
 *
 * AMENDED 2026-10-09 (design sync, the Claude Design export of 2026-10-09): the tab IS the test card —
 * the same `TestChatPanel` the Test console draws (`layout="card"`), with Text, Browser voice and the
 * phone ("My phone", or "Call me" for a survey) in one place, 560 wide. The docked panel steps aside on
 * this tab (`agent-screen.tsx`). The phone test runs in the card, so the separate phone form is gone.
 */
import type { ReactNode } from "react";

import type { VoiceAgentView } from "../../../api/gateway.js";
import { TestChatPanel } from "../../test-console/test-chat-panel.js";

export function TestCallTab({ voiceAgent }: { readonly voiceAgent: VoiceAgentView }): ReactNode {
  return (
    <div className="c-va-test-tab">
      <TestChatPanel
        layout="card"
        voiceModes
        voiceAgent={voiceAgent}
        voiceAgentId={voiceAgent.voiceAgentId}
        voiceAgentName={voiceAgent.displayName}
        languageCode={voiceAgent.languageCode}
        onOpenTestCall={null}
      />
    </div>
  );
}
